import UltMeta, { Meta } from "./UltMeta/index";

export enum E_TYPE {
    NEW_USER = 1, // 新注册用户
    NEW_SHIPPING_REQUIREMENT_PLAT = 2, // 新找船需求
    NEW_SHIPPING_REQUIREMENT_ACCEPT = 3, // 新报价信息
    NEW_EMPTY_SHIP = 4 // 新空船信息
}

/**
 * 类型
 */
class Type extends UltMeta {
    NEW_USER = new Meta(E_TYPE.NEW_USER, "新注册用户");
    NEW_SHIPPING_REQUIREMENT_PLAT = new Meta(E_TYPE.NEW_SHIPPING_REQUIREMENT_PLAT, "新找船需求");
    NEW_SHIPPING_REQUIREMENT_ACCEPT = new Meta(E_TYPE.NEW_SHIPPING_REQUIREMENT_ACCEPT, "新报价信息");
    NEW_EMPTY_SHIP = new Meta(E_TYPE.NEW_EMPTY_SHIP, "新空船信息");
}

export const TYPE = new Type();


class State extends UltMeta {
    WAITING = new Meta(0, "未处理");
    FOLLOWING = new Meta(1, "持续跟进");
    FINISHED = new Meta(2, "已处理");
}

export const STATE = new State();